<div class="flex flex-1 items-center gap-3x" [formGroup]="formGroup">
  <lxm-button
    *ngIf="!readonly"
    [type]="highlightButtons ? (hasValue ? 'green' : 'grey') : 'grey'"
    class="size-17x"
    icon="minus-small"
    (click)="decrement()"
  ></lxm-button>
  <lxm-input
    class="flex min-w-0 shrink grow text-center"
    [for]="for"
    type="numeric"
    [suffix]="suffix"
    [digits]="digits"
    inputClass="min-w-0"
    [readonly]="readonly"
    (blur)="onInputBlur.emit($event)"
    [allowNegativeNumbers]="false"
  ></lxm-input>
  <lxm-button
    *ngIf="!readonly"
    [type]="highlightButtons ? (hasValue ? 'green' : 'grey') : 'grey'"
    class="size-17"
    icon="plus-small"
    (click)="increment()"
  ></lxm-button>
</div>


<ng-content select="[validation-errors]"></ng-content>